import type { ShellContextData } from '@omni/kit/contexts/ShellContext/types';
import '@omni/kit/localization';

import versionData from './version.generated.json';

export {
  ShellContextProvider,
  WebShellContextProvider,
  useShellContext,
} from './contexts/ShellContext';

export { SUBSPLASH_AUTH_PROVIDER_ID } from './constants/identifiers';

export const { version, shortCommitHash } = versionData;

export { default as AuthProviderList } from './auth/AuthProviderList';
export { default as AuthScreen } from './auth/AuthScreen';
export type { AuthScreenProps } from './auth/AuthScreen';
export { SourceContextProvider, SOURCE_TYPES } from './contexts/SourceContext';

export { createDeepLink } from './utilities/utilities';

export { default as KitPlayer } from './components/KitPlayer';

export { setEnv } from './Environment';
export type { ShellContextData };
